import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {MatBadgeModule} from '@angular/material/badge';
import { FormsModule } from '@angular/forms';
import { LoaderModule, LoaderService } from '@ff/loader';
import { CoreModule } from '@ff/core';
import { DialogComponent } from './components/dialog/dialog.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule, MomentDateModule, MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MonthYearPickerComponent } from './components/month-year-picker/month-year-picker.component';
import { MonthYearTableComponent } from './components/month-year-table/month-year-table.component';
import { FormatNumberDisplayDirective } from './directives/format-number-display.directive';
import { FormatPercentageDisplayDirective } from './directives/format-percentage-display.directive';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { RouterModule } from '@angular/router';
import { UserService } from '@ff/user';
import { MatRadioModule } from '@angular/material/radio';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MyMatPaginatorIntl } from './helpers/my-mat-paginator-intl';
import { DragAndDropDirective } from './directives/drag-and-drop.directive';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ControlErrorsDirective } from './directives/control-errors.directive';
import { FormSubmitDirective } from './directives/form-submit.directive';
import { ControlErrorComponent } from './components/control-error/control-error.component';
import { ControlErrorContainerDirective } from './directives/control-error-container.directive';
import { UppercaseFirstLetterPipe } from '../_pipes/uppercasefirstletter.pipe';
import { SocialSecurityNbDirective } from './directives/social-security-nb.directive';
import { ThousandDirective } from './directives/thousands.directive';
import { MonthYearRangePickerComponent } from './components/month-year-range-picker/month-year-range-picker.component';
import { MatNativeDateModule, DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import * as Editor from '../../../assets/libraries/ckeditor/ckeditor';
import { isNil } from 'lodash';


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json?cb=' + new Date().getTime());
}

@NgModule({
  declarations: [
    DialogComponent,
    MonthYearPickerComponent,
    MonthYearRangePickerComponent,
    MonthYearTableComponent,
    FormatNumberDisplayDirective,
    FormatPercentageDisplayDirective,
    DragAndDropDirective,
    ControlErrorsDirective,
    FormSubmitDirective,
    ControlErrorComponent,
    ControlErrorContainerDirective,
    SocialSecurityNbDirective,
    UppercaseFirstLetterPipe,
    ThousandDirective,
  ],
  providers: [
    UserService,
    { provide: MatPaginatorIntl, useClass: MyMatPaginatorIntl },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        {
            provide: MAT_DATE_FORMATS, useValue: {
                parse: {
                    dateInput: 'DD.MM.YYYY',
                },
                display: {
                    dateInput: 'DD.MM.YYYY',
                    monthYearLabel: 'MMM YYYY',
                    dateA11yLabel: 'LL',
                    monthYearA11yLabel: 'MMMM YYYY',
                },
            },
        },
    
  ],
  imports: [

    // Angular

    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    
    // FF Packages
    LoaderModule,
    CoreModule,

    // Others

    // Angular Material
    MatFormFieldModule,
    MatAutocompleteModule,
    MatNativeDateModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    MatToolbarModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatSidenavModule,
    MatSnackBarModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSelectModule,
    NgSelectModule,
    MatDatepickerModule,
    MatDividerModule,
    MatCheckboxModule,
    MatRadioModule,
    MatBottomSheetModule,
    TranslateModule,
    MatExpansionModule,
    MatBadgeModule,
    MatSlideToggleModule,
    NgxMatSelectSearchModule,
    RouterModule,
    DragDropModule,
    NgxMatSelectSearchModule,
    CKEditorModule
  ],
  exports: [

    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    // FF Packages
    LoaderModule,
    CoreModule,
    
    // Others
    TranslateModule,

    // Angular Material
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    MatToolbarModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    MatCardModule,
    MatSidenavModule,
    MatSnackBarModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSelectModule,
    MatDatepickerModule,
    MatDividerModule,
    MatCheckboxModule,
    MatRadioModule,
    NgxMatSelectSearchModule,
    MatBadgeModule,
    // MomentDateModule,
    MatBottomSheetModule,
    MatExpansionModule,
    MatSlideToggleModule,
    DragDropModule,

    // Component
    MonthYearPickerComponent,
    MonthYearTableComponent,
    MonthYearRangePickerComponent,

    FormatNumberDisplayDirective,
    FormatPercentageDisplayDirective,

    ControlErrorsDirective,
    FormSubmitDirective,
    ControlErrorComponent,
    ControlErrorContainerDirective,
    SocialSecurityNbDirective,
    UppercaseFirstLetterPipe,
    ThousandDirective,
    CKEditorModule
  ]
})
export class SharedModule {

  public constructor(
    private adapter: DateAdapter<any>,
    private translate: TranslateService,
  ) {
    this.translate.onLangChange
      .subscribe(({ lang }: LangChangeEvent) => {
        this.adapter.setLocale(lang);
    });
  }
}

export function loaderShow(_loaderService: LoaderService) {
  if (!_loaderService.isVisible()) {
    _loaderService.show();
  }
}

export function loaderHide(_loaderService: LoaderService) {
  if (_loaderService.isVisible()) {
    _loaderService.hide();
  }
}

export function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

export function getEditor() {
  return Editor;
}

export function onReady(editor) {
  editor.ui.getEditableElement().parentElement.insertBefore(
      editor.ui.view.toolbar.element,
      editor.ui.getEditableElement()
  );
}

export function getQueryParams(params) {
  let queryParams = '';
  if(!isNil(params)) {
    Object.keys(params).forEach((key) => {
      queryParams += !isNil(params[key]) ? `${key}=${params[key]}&` : '';
    });
  }
  return queryParams;
}